import React from 'react';
import PropTypes from 'prop-types';
import { Tree, Spin } from 'antd';
import Search from 'components/Search';
import Icon from 'components/Icon';

function noop() {}

export default class ListSelectTreeSource extends React.Component {
  static defaultProps = {
    dataSource: [],
    titleText: '',
    treeKey: 'key',
    treeTitleKey: 'title',
    showSearch: false,
    handleClear: noop,
    handleFilter: noop,
    handleSelect: noop,
    handleSelectAll: noop
  };

  static propTypes = {
    prefixCls: PropTypes.string,
    treeData: PropTypes.array,
    showSearch: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
    titleText: PropTypes.string,
    treeKey: PropTypes.string,
    treeTitleKey: PropTypes.string,
    style: PropTypes.object,
    handleClear: PropTypes.func,
    notFoundContent: PropTypes.string,
    filter: PropTypes.string,
    handleFilter: PropTypes.func,
    treeRender: PropTypes.func,
    loading: PropTypes.bool,
    flatTreeData: PropTypes.array
  };

  state = {
    autoExpandParent: true,
    searchList: []
  };

  handleFilter = value => {
    this.renderFilterResult(value);
    this.props.handleFilter(value);
  };

  handleClear = () => {
    this.renderFilterResult('');
    this.props.handleFilter('');
  };

  renderTreeNodes = data => {
    const { treeKey, treeTitleKey } = this.props;
    
    return data.map(item => {
      const treeProps = {
        ...item,
        key: item[treeKey],
        title: item[treeTitleKey],
        dataRef: item
      };

      if (item.children) {
        return (
          <Tree.TreeNode {...treeProps} icon={<Icon className="material-folder-o" />}>
            {this.renderTreeNodes(item.children)}
          </Tree.TreeNode>
        );
      }
      return <Tree.TreeNode {...treeProps} />;
    });
  }

  createTreeNodes = data => {
    //左边源列表 checked 节点数据都是分散的node，需要拼装成树
    let tempData = (nodeList => {
      //未选中任何树节点
      if (!nodeList || nodeList.length === 0) {
        return [];
      }
      /**
       * 定义“数组-链表”，该数组链表的每一项相当于一深度为2的小树
       * Map的key相当于“数组”的某一项，Map的value相当于该key所拥有的“链表”
       * 这里，key为父节点ID，list为具有相同父节点ID的所有同级子节点实体list（属于该父节点的所有子节点）
       */
      let tempMap = new Map();

      nodeList.map(item => {
        item.children = null;
        
        //pid对应子节点数组还未放到map中
        if (!tempMap.get(item.pid)) {
          let tempList = [];
          tempList.push(item);
          tempMap.set(item.pid, tempList);

        } else {
          let tempList = tempMap.get(item.pid);
          tempList.push(item);
        }
      });
      // 以上，至此，第一遍遍历完毕，非叶子节点都拥有一个“数组-链表项”，也即“最小的树”已创建完毕

      // 以下，对“数组链表”Map进行遍历，更改“最小的树”的从属关系（更改指针指向），也即把所有小树组装成大树
      tempMap.forEach((value, key, map) => {
        let tempList = value;
        
        tempList.map(item => {
          let findList = tempMap.get(item.key);
          if (findList) item.children = findList;
        });
      });

      //返回一级菜单数组，所有一级菜单的pid都是-1
      return tempMap.get("-1");
    })(data);

    return tempData && this.renderTreeNodes(tempData);
  };

  renderFilterResult = filter => {
    const { flatTreeData, treeTitleKey, asyncSearch } = this.props;
    if (asyncSearch) {
      const promise = asyncSearch(filter);
      if (promise.then) {
        promise.then(listItem => {
          this.setState({
            searchList: listItem
          });
        });
      }
    } else {
      this.setState({
        searchList: flatTreeData.filter(
          item => item[treeTitleKey].indexOf(filter) >= 0
        )
      });
    }
  };

  renderSearchItem = searchList =>
    searchList.map((item, index) => (
      <li
        className="list-comp-item"
        title={item[this.props.treeTitleKey]}
        key={item[this.props.treeKey]}
        onClick={() => this.handleSelect(item)}
      >
        <span className="list-comp-item-body">
          {item[this.props.treeTitleKey]}
        </span>
      </li>
    ));

  handleSelect = selectedItem => {
    const { checkedNodes } = this.props;
     
    let _checkedNodes = checkedNodes ? [...checkedNodes] : [];

    _checkedNodes.push(selectedItem);

    this.props.onChecked(_checkedNodes);
  };

  render() {
    const {
      prefixCls,
      loading,
      titleText,
      loadData,
      filter,
      showSearch,
      style,
      treeData
    } = this.props;

    const { autoExpandParent, searchList } = this.state;

    let { searchPlaceholder, notFoundContent } = this.props;

    const showTree = (
      <Tree
        showLine
        defaultExpandAll
        autoExpandParent={autoExpandParent}
        loadData={loadData}
      >
        {this.createTreeNodes(treeData)}
      </Tree>
    );

    return (
      <div className={prefixCls} style={style}>
        <div className={`${prefixCls}-header tree-title`}>{titleText}</div>
        <div
          className={
            showSearch
              ? `${prefixCls}-body ${prefixCls}-body-with-search`
              : `${prefixCls}-body`
          }
        >
          {showSearch ? (
            <div className={`${prefixCls}-body-search-wrapper`}>
              <Search
                prefixCls={`${prefixCls}-search`}
                onChange={this.handleFilter}
                handleClear={this.handleClear}
                placeholder={searchPlaceholder || '请输入搜索内容'}
              />
            </div>
          ) : null}
          <div className={`${prefixCls}-body-content tree-content`}>
            {filter ? (
              <ul className="tree-filter-result">
                {this.renderSearchItem(searchList)}
              </ul>
            ) : null}
            {treeData.length ? (
              showTree
            ) : (
              <div className={`${prefixCls}-body-content-not-found`}>
                {loading ? (
                  <Spin spinning={loading} />
                ) : (
                  notFoundContent || '列表为空'
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/TransferSelectTree/ListSelectTreeTarget.js